import { Box, CssBaseline, Toolbar } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { MainListItems } from '../../components/Navbar/listItems';
import NewNavbar from '../../components/Navbar/New/Navbar';
import Sidebar from '../../components/Navbar/Sidebar';
import theme from '../../mui-theme';
const drawerWidth = 240;

const DocumentationLayout = ({ children, onSidebarNavigate }) => {
  const [open, setOpen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleDrawer = () => setOpen((prevOpen) => !prevOpen);

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <CssBaseline />
      <NewNavbar />
      <Box
        sx={{
          flexShrink: 0,
          position: 'fixed',
          height: '100vh',
          zIndex: 1200,
        }}
      >
        <Sidebar
          theme={theme}
          MainListItems={MainListItems}
          open={open}
          toggleDrawer={toggleDrawer}
          type="documentation"
          onSidebarNavigate={onSidebarNavigate} 
        />
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: open ? `${drawerWidth}px` : 7,
          overflowY: 'auto',
          height: '100vh',
        }}
      >
        <Toolbar />
        <Box sx={{ p: 2 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default DocumentationLayout;
